<template>
<svg
    class="ActivityRings"
    :class="{animate: runAnimation}"
    viewBox="0 0 240 240"
    style="transform: rotate(-90deg); transform-origin: 50%;"
>
    <g class="ring">
        <circle class="background"
            cx="50%" cy="50%"
            :stroke-width="width"
            :stroke="background"
            :r="circleRadius" />

        <circle class="completed"
            cx="50%" cy="50%"
            :stroke-width="width"
            :stroke="color"
            :r="circleRadius"
            ref="completed"
            :stroke-dasharray="dashArray" />
    </g>
</svg>
</template>

<script>
export default {
    props: {
        width: {
            type: Number,
            default: 50
        },
        size: {
            type: Number,
            default: 90
        },
        ring: Number,
        color: {
            type: String,
            default: '#56BFAE'
        },
        background: {
            type: String,
            default: 'rgba(86, 191, 174, 0.2)'
        },

        animate: {
            type: Boolean
        }
    },


    data () {
        return {
            circleRadius: this.size,
            lastPosition: [],
            newPosition: [],
            runAnimation: false
        }
    },

    computed: {
        circle () {
            if (!this.ring) this.ring = 0;
            return this.CalcDashArray(this.ring, this.circleRadius);
        },

        dashArray () {
            if (this.animate && this.$el) {
                return this.lastPosition || [];
            } else {
                return this.circle;
            }
        }
    },

    watch: {
        circle (newVal, oldVal) {
            this.setCssVars(newVal, oldVal);
        }
    },

    methods: {
        CalcDashArray (val, radius) {
            let length = Math.round(2 * Math.PI * radius);
            return [Math.round(length/100 * val),length];
        },

        setCssVars (newVal, oldVal) {
            if (this.$el) {
                this.$el.style.setProperty('--last-position', oldVal);
                this.$el.style.setProperty('--new-position', newVal);
            }

            // Trigger animation
            if (this.animate) {
                this.$refs.completed.style['stroke-dasharray'] = oldVal;
                this.runAnimation = false;

                if (process.client) {
                    setTimeout(() => {
                        this.runAnimation = true;
                    }, 50);
                }
                
            }
        },
    }
}
</script>

<style scoped>
    .animate .completed {
        animation: DialProgress 0.5s cubic-bezier(0.77, 0, 0.175, 1) forwards;
    }

    @keyframes DialProgress {
        0% {stroke-dasharray: var(--last-position);}
        100% {stroke-dasharray: var(--new-position);}
    }
</style>
